import { store } from "../redux/store/configureStore";

export const isCorelabUser = () => {
	const state = store.getState();
	const email = state?.auth?.userData?.email || "";
	return email.endsWith("@corelab.com.br");
};

// BYP-1331 em validação: agrupamento de incidência de hora extra liberado só para estes clientes
const CLIENTES_AGRUPAMENTO_INCIDENCIA_HORA_EXTRA = [
	"zintra",
	"tempodeviver",
	"gnovalondrina",
];

export const isAgrupamentoIncidenciaHoraExtraEnabled = () => {
	return true;
	const state = store.getState();
	const client = state?.auth?.client || "";
	return CLIENTES_AGRUPAMENTO_INCIDENCIA_HORA_EXTRA.includes(client);
};

// Nova regra de banco de horas: combinar faixa diurna e noturna em primeira/ultima_faixa_entrada, liberado só para este cliente
const CLIENTES_COMBINAR_FAIXA_DIURNA_NOTURNA = [
	"kgmlondrina",
	"matsumoto2",
];

export const isCombinarFaixaDiurnaNoturnaEnabled = () => {
	return true;
	const state = store.getState();
	const client = state?.auth?.client || "";
	return CLIENTES_COMBINAR_FAIXA_DIURNA_NOTURNA.includes(client);
};

const SLUGS_REINDEXAR_BATIDAS_PERMITIDOS = [
	"zintra",
	"hotelboulevard2",
	"ferguileestofados",
	"rjluizconfeccoes",
	"papelrdembalagens",
	"prefeituracalifornia",
	"kgmlondrina",
	"wrodrigues_embalagens",
	"santori_marques",
	"condominioalamedaeco",
	"edificioflorais",
	"condominioabsoluto",
	"chiquettiengenharia",
	"gnovalondrina",
	"compositoindustria",
	"am_transportes",
	"lage_renzeti",
	"teste_jose",
	"matsumoto2",
];

export const isReindexarBatidasEnabled = () => {
	const mainCompanyData = localStorage.getItem("@mainCompany");
	if (!mainCompanyData) return false;

	try {
		const { slug } = JSON.parse(mainCompanyData);
		return SLUGS_REINDEXAR_BATIDAS_PERMITIDOS.includes(slug);
	} catch (e) {
		return false;
	}
};
